


















































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {FamilyVersionManagement} from '@/modules/neovehicle/models/family';
import {FamilyVersionFilter} from '@/modules/neovehicle/models/filters';
import {Brand, VehicleType, vehicleTypes} from '@/modules/neovehicle/models';
import debounce from 'lodash/debounce';
import {v4 as uuidv4} from 'uuid';

@Component
export default class extends Vue {
  @Prop({ type: Array, required: true })
  public data: FamilyVersionManagement[];

  @Prop({ type: Boolean, required: true })
  public loading: boolean;

  @Prop({type: Array})
  public brands: Brand[];

  @Prop({type: Array})
  public vehicleTypesSearch: VehicleType[];

  @Prop({ type: Object, required: true })
  public filter: FamilyVersionFilter;

  @Prop({type: Boolean, default: false})
  public buttonDisabled: boolean;

  public pagination = {
    sortBy: 'name',
    descending: false,
  };

  public checkboxSelected: FamilyVersionManagement[] = [];
  public vehicleTypes = vehicleTypes;
  public checkboxAll: boolean = false;
  public uuidv4 = uuidv4;

  public headers = [
    {text: '', value: 'checkbox', sortable: false, width: 10, checkbox: true},
    {text: 'Código', value: 'idFamilyVersion', sortable: true, width: 100},
    {text: 'Tipo de Veículo', value: 'idVehicleTypes', width: 150},
    {text: 'Bandeira', value: 'brandName'},
    {text: 'Versão/Família', value: 'familyVersionName'},
    {text: 'Família', value: 'familyVersionName'},
    {text: 'Grupo/Família', value: 'familyGroupName'},
    {text: '', value: '', sortable: false, width: 50},
  ];

  public get handleSearchVersion() {
    return debounce(() => {
      this.$emit('search');
    }, 1000);
  }

  @Watch('checkboxSelected')
  public watchCheckboxSelected() {
    this.$emit('select', this.checkboxSelected);
  }

  public resetSelect() {
    this.checkboxSelected = [];
    this.checkboxAll = false;
  }

  public handlePagination() {
    this.checkboxAll = false;
  }

  public handleRemove(familyVersion: FamilyVersionManagement) {
    this.$emit('remove', familyVersion);
  }

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public handleEdit(familyVersion: FamilyVersionManagement) {
    this.$emit('edit', familyVersion);
  }

  public handleCheck(checked: boolean) {
    this.$nextTick(() => {
      [...document.querySelectorAll('input[data-id]')]
        .map((el: any) => Number(el.dataset.id))
        .forEach((id: number) => {
          if (checked) {
            const familyVersions = this.data.filter((m: FamilyVersionManagement) => m.idFamilyVersion === id);

            if (familyVersions.length) {
              this.checkboxSelected.push(familyVersions[0]);
            }
          } else {
            this.checkboxSelected = this.checkboxSelected.filter((m: FamilyVersionManagement) => m.idFamilyVersion !== id);
          }
        });
    });
  }

  public handleSelectMove() {
    this.$emit('click-select-move');
  }
}
